import { render, staticRenderFns } from "./BasicFacts.vue?vue&type=template&id=0dd69dd5&scoped=true&"
import script from "./BasicFacts.vue?vue&type=script&lang=js&"
export * from "./BasicFacts.vue?vue&type=script&lang=js&"
import style0 from "./BasicFacts.vue?vue&type=style&index=0&id=0dd69dd5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dd69dd5",
  null
  
)

export default component.exports